import { createFeatureHook } from '@edreamsodigeo/frontend-core';

import { BAGS_NAMING_CLEANUP } from '@/versionedComponents';
import { useFlowTools } from '@/flowTools/useFlowTools';

const useBagsNamingCleanupVariation = (): boolean => {
  const { isMobile } = useFlowTools();
  return isMobile;
};

export const useGetBagsNamingCleanup = createFeatureHook({
  name: BAGS_NAMING_CLEANUP,
  variations: [(): boolean => false, useBagsNamingCleanupVariation],
  version: 1,
});
